import { gql } from '@grandvisionhq/graphql';
import { address } from './address.js';
import { cartAppliedDiscounts } from './cart-applied-discounts.js';
import { discount } from './discount.js';
import { legacyProduct } from './legacy-product.js';
import { lineItems } from './line-item.js';
import { lineItemPrice } from './line-item-price.js';

const cartDetails = gql`
  fragment CartDetailsFragment on Cart {
    __typename
    id
    checkoutState
    hasDistinctDeliveryEstimations
    hasSubscription
    customerDetails {
      email
      phone
      customerType
      dateOfBirth
    }
    invoiceDetails {
      certifiedEmail
      vatId
      certifiedRecipientCode
    }
    shippingAddress {
      ...AddressFragment
    }
    shippingMethod {
      id
      key
      freeAbove
      pricing {
        taxRate
        priceWithoutDiscounts
      }
    }
    billingAddress {
      ...AddressFragment
    }
    appliedDiscounts {
      name {
        locale
        value
        __typename
      }
      code
      requiresDiscountCode
      __typename
    }
    loyaltyDetails {
      cardNumber
      points
      cardNumberType
    }
    numberOfItems
    price {
      subtotal
      discount {
        amount
        percentage
        appliedDiscounts {
          id
          type
          amount
        }
        __typename
      }
      net
      gross
      tax {
        amount
        portions {
          rate
          amount
          __typename
        }
        __typename
      }
      shippingPrice
      paymentMethodPrice
      __typename
    }
    vouchers {
      code
      isActive
      name
      state
      __typename
    }
    isAccountRequired
    additionalCartCostLineItems {
      id
      sku
      quantity
    }
    serviceStore {
      globalStoreId
    }
    hasAlternativeShippingState
    ...LineItemsFragment
    ...CartAppliedDiscountsFragment
  }
  ${address}
  ${legacyProduct}
  ${lineItemPrice}
  ${discount}
  ${lineItems}
  ${cartAppliedDiscounts}
`;

export { cartDetails };
//# sourceMappingURL=cart-details.js.map
